import { useState, useCallback, useMemo, useEffect } from 'react';
import { downloadDocumentFromUrl } from '../../utils/helpers';
import { Modal, Button, Table, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { getRule } from '../../utils/api';
import Loader from '../Loader';
import Header from '../Header';
import { faCar, faEllipsis, faTrashCan, faArrowsTurnToDots, faPencil, faPlus, faCirclePlus, faFile, faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency, formatDateToMMDDYYYYWithTime, openDocumentInNewTab } from '../../utils/helpers';
import ShowMenuButton from '../ShowMenuButton';
import Error from '../Error';

const ViewRuleModal = ({ show, onHide, rule }) => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, [show]);

    const fetchData = async () => {
        if (show) {
            setLoading(true);
            setError(null);
            const data = rule && await getRule(rule.Id);
            if (data) {
                setData(data);
            }
            else {
                setError('Failed to fetch business Partner');
            }
            setLoading(false);
        }
        else {
            setData([]);
            setError(null);
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>View Rule (Id={rule?.Id})</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ padding: 10 }}>
                        {loading ? <Loader /> : error ? <Error /> : (
                            <>
                                <Header title={rule?.Vin} description={'Rule details for Id = ' + rule?.Id} />
                                <Row>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    ID
                                                </th>
                                                <th tyle={{ whiteSpace: 'nowrap', }}>
                                                    State
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Description
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[data?.Rule]?.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.State?.Name}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Description}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Row>
                                <br /><br />
                                <Row>
                                    <div>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', }}>
                                            Settings
                                        </div>

                                        <Table striped bordered hover responsive>
                                            <thead>
                                            <tr>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Name
                                                </th>
                                                <th tyle={{ whiteSpace: 'nowrap', }}>
                                                    Value
                                                </th>
                                            </tr>
                                        </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '50%' }}>
                                                        ProcessTradeIn <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "ProcessTradeIn")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.ProcessTradeIn ? 'Yes' : 'No'}</td>
                                                </tr>
                                                 <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '50%' }}>Max Purchase Price <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxPurchasePrice")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxPurchasePrice}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MaxTrailerPurchasePrice <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxTrailerPurchasePrice")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxTrailerPurchasePrice}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MaxPurchaseQty <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxPurchaseQty")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxPurchaseQty}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MaxSaleQty <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxSaleQty")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxSaleQty}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MaxTradeIn <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxTradeIn")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxTradeIn}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MaxGvw <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxGVW")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxGvw}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MaxOverMatch <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxOverMatch")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxOverMatch}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MaxUnderMatch <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MaxUnderMatch")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MaxUnderMatch}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>LimitedToSameClass <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "LimitedToSameClass")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.LimitedToSameClass}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>LimitedToSameStateTitling <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "LimitedToSameStateTitling")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.LimitedToSameStateTitling}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>PrioritizeNewOverUsedVehicles <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "PrioritizeNewOverUsedVehicles")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.PrioritizeNewOverUsedVehicles}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>PurchaseInXdays <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "PurchaseInXDays")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.PurchaseInXdays}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>MinLeaseLength <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "MinLeaseLength")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.MinLeaseLength}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>SeedPoolSize <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "SeedPoolSize")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.SeedPoolSize}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>PurchasePriorityOrder <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "PurchasePriorityOrderId")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.PurchasePriorityOrder?.Description}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>SalePriorityOrder <br/> 
                                                        <span style={{fontSize:12}}>{data?.RuleMetadata?.find(c=>c.ColumnName === "SalePriorityOrderId")?.Description}</span>
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', background: 'white' }}>{data?.Rule?.SalePriorityOrder?.Description}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                            </>
                        )}
                    </div>
                </Modal.Body>

            </Modal >
        </>
    );
};

export default ViewRuleModal;